var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDriveTimelineItemActionLabel, getDriveTimelineItemUserLabel, mapDocumentTimelineItems } from '@web/components/ItemDetails/DriveItemDetails/driveDailyTimelineUtils';
import { DriveDocumentEventsLogFilters } from '@web/components/ItemDetails/DriveItemDetails/DriveDocumentEventsLogFilters';
import { DriveDocumentEventsTable } from '@web/components/ItemDetails/DriveItemDetails/DriveDocumentEventsTable';
import { AIButton } from '@web/components/layout/AIInsights/AIButton';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import { InformationCircle } from '@web/components/layout/InformationCircle/InformationCircle';
import Loading from '@web/components/layout/Loading';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { InsightTypeEnum } from '@workalizer/shared';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
export var DriveDocumentEventsLog = function (_a) {
    var _b, _c, _d;
    var documentId = _a.documentId;
    var t = useTranslation().t;
    var _e = useFilters(), dateFrom = _e.dateFrom, dateTo = _e.dateTo, documentEventsUser = _e.documentEventsUser, documentEventsAction = _e.documentEventsAction, documentEventsSubAction = _e.documentEventsSubAction;
    var _f = useState(1), tablePage = _f[0], setTablePage = _f[1];
    var _g = trpc.documentEventsLog.useQuery({
        documentId: documentId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: documentEventsUser !== null && documentEventsUser !== void 0 ? documentEventsUser : undefined,
        action: (_b = documentEventsAction) !== null && _b !== void 0 ? _b : undefined,
        subAction: (_c = documentEventsSubAction) !== null && _c !== void 0 ? _c : undefined
    }), eventsLog = _g.data, isLoading = _g.isLoading, refetch = _g.refetch;
    useEffect(function () {
        setTablePage(1);
    }, [
        documentId,
        dateFrom,
        dateTo,
        documentEventsUser,
        documentEventsAction,
        documentEventsSubAction
    ]);
    var items = mapDocumentTimelineItems((_d = eventsLog === null || eventsLog === void 0 ? void 0 : eventsLog.items) !== null && _d !== void 0 ? _d : [], t);
    if (isLoading && !eventsLog) {
        return _jsx(Loading, {});
    }
    return (_jsxs("div", { children: [_jsxs("div", __assign({ className: "mb-4 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-2 mx-2" }, { children: [_jsx("h3", __assign({ className: "text-xl font-semibold text-tremor-content-strong" }, { children: t('driveItemDetails.documentEventsLog.title') })), _jsx(InformationCircle, { text: t('widgetTitleDescriptions.itemDetails.driveDocumentEventsLog') })] })), _jsxs("div", __assign({ className: "flex flex-wrap items-end gap-3 lg:justify-end" }, { children: [_jsx(DriveDocumentEventsLogFilters, { documentId: documentId }), _jsx(ExportMenu, { fileName: t('driveItemDetails.documentEventsLog.title'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        return [2 /*return*/, items.map(function (item) {
                                                var _a;
                                                var _b;
                                                return (_a = {},
                                                    _a[t('driveItemDetails.dailyTimelineTable.when')] = format(item.startDate, 'd MMM yyyy - HH:mm'),
                                                    _a[t('driveItemDetails.dailyTimelineTable.action')] = getDriveTimelineItemActionLabel(item, t),
                                                    _a[t('driveItemDetails.dailyTimelineTable.by')] = getDriveTimelineItemUserLabel(item),
                                                    _a[t('driveItemDetails.dailyTimelineTable.team')] = (_b = item.orgUnitTitle) !== null && _b !== void 0 ? _b : '',
                                                    _a);
                                            })];
                                    });
                                }); }, disabled: isAiButtonDisabled(items) }), _jsx(AIButton, { insightsData: items, insightType: InsightTypeEnum.documentEventsLog, refetch: refetch })] }))] })), _jsx(DriveDocumentEventsTable, { items: items, page: tablePage, onPageChange: setTablePage, variant: "bordered", wrapperClassName: "" })] }));
};
